import React from 'react'

function IsLoading() {
  return (
    <div style={{display:'flex',justifyContent:'center',alignItems:'center',flexDirection:'column', zIndex: 9999}}>    
      <img width='20%'src={`${process.env.REACT_APP_S3}public/isLoading.gif`}></img>
    </div>
  )
}

export default IsLoading
